import { useSelector } from 'react-redux';

import { isActionsPausedForEnterprise } from '@/constants/actionsPaused';

/**
 * Retorna true quando a empresa do usuário logado está com as ações pausadas
 * (ver ACTIONS_PAUSED_ENTERPRISE_IDS em constants/actionsPaused.js)
 *
 * @example
 * const actionsPaused = useActionsPaused();
 * {!actionsPaused && <Button>Novo</Button>}
 */
const useActionsPaused = () => {
    const enterpriseId = useSelector((state) => state.auth.user?.enterprise?.id);

    return isActionsPausedForEnterprise(enterpriseId);
};

export default useActionsPaused;
